"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/toConsumableArray"));
var _AwayStatusIndicator = _interopRequireDefault(require("./AwayStatusIndicator"));
var _TypingStatusIndicator = _interopRequireDefault(require("./TypingStatusIndicator"));
var _default = exports.default = {
  components: {
    AwayStatusIndicator: _AwayStatusIndicator.default,
    TypingStatusIndicator: _TypingStatusIndicator.default
  },
  props: ['network', 'user', 'nicklist'],
  data: function data() {
    return {
      avatarUrl: ''
    };
  },
  computed: {
    dataAttributes: function dataAttributes() {
      var attrs = Object.create(null);
      attrs['data-nick'] = this.user.nick.toLowerCase();
      if (this.user.account) {
        attrs['data-account'] = this.user.account.toLowerCase();
      }
      var userMode = this.nicklist.buffer.userMode(this.user);
      if (userMode) {
        attrs['data-mode'] = userMode;
      }
      return attrs;
    },
    userColour: function userColour() {
      return this.nicklist.useColouredNicks ? this.user.getColour() : '';
    },
    userModePrefix: function userModePrefix() {
      return this.nicklist.buffer.userModePrefix(this.user);
    },
    userTypingState: function userTypingState() {
      var status = this.user.typingStatus(this.nicklist.buffer.name).status;
      return status;
    }
  },
  watch: {
    user: {
      immediate: true,
      deep: true,
      handler: function handler(newUser) {
        this.updateAvatar(newUser);
      }
    }
  },
  methods: {
    handleClick: function handleClick() {
      this.nicklist.openUserbox(this.user);
    },
    generateAvatarUrl: function generateAvatarUrl(nick) {
      var _context, _context2, _context3;
      var styles = ['bottts', 'bottts-neutral', 'fun-emoji', 'thumbs'];
      var format = 'png';
      var size = '64';
      var hash = (0, _toConsumableArray2.default)(nick).reduce(function (acc, c) {
        return acc + c.charCodeAt(0);
      }, 0);
      var index = hash % styles.length;
      var selectedStyle = styles[index];
      return (0, _concat.default)(_context = (0, _concat.default)(_context2 = (0, _concat.default)(_context3 = "https://api.dicebear.com/6.x/".concat(selectedStyle, "/")).call(_context3, format, "?seed=")).call(_context2, encodeURIComponent(nick), "&size=")).call(_context, size);
    },
    updateAvatar: function updateAvatar(user) {
      var _user$avatar, _user$metadata;
      if (!user) return;
      if (typeof user.avatar === 'string') {
        this.avatarUrl = user.avatar;
      } else if ((_user$avatar = user.avatar) !== null && _user$avatar !== void 0 && _user$avatar.small) {
        this.avatarUrl = user.avatar.small;
      } else if ((_user$metadata = user.metadata) !== null && _user$metadata !== void 0 && _user$metadata.avatar) {
        this.avatarUrl = user.metadata.avatar;
      } else if (user.avatarUrl) {
        this.avatarUrl = user.avatarUrl;
      } else {
        this.avatarUrl = this.generateAvatarUrl(user.nick);
      }
    },
    onError: function onError() {
      this.avatarUrl = this.generateAvatarUrl(this.user.nick);
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["NicklistUser"]
window._kiwi_exports.components.NicklistUser = exports.default ? exports.default : exports;
